import { render, staticRenderFns } from "./ClientEditModal.vue?vue&type=template&id=6976ef0a&scoped=true&"
import script from "./ClientEditModal.vue?vue&type=script&lang=js&"
export * from "./ClientEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6976ef0a",
  null
  
)

export default component.exports